<template>
  <card>
    <template v-slot:title>
      {{ $t('participants.contact') }}
    </template>
    <template v-slot:body>
      <ria-input 
        name="email" 
        :label="$t('participants.email')" 
        validation="required|email" 
        type="email" 
        :value="order.email" 
        ref="email" 
        @change="changeValue" />
      <ria-input 
        name="firstname" 
        :label="$t('participants.name')" 
        validation="required" 
        type="text" 
        :value="order.firstname" 
        ref="firstname" 
        @change="changeValue" />
      <ria-input 
        name="lastname" 
        :label="$t('participants.lastname')" 
        validation="required" 
        type="text" 
        :value="order.lastname" 
        ref="lastname" 
        @change="changeValue" />
      <ria-input 
        name="phone" 
        :label="$t('participants.phone')" 
        :validation="phoneValidation" 
        type="tel"
        ref="phone"
        :value="order.phone" 
        @change="changeValue"/>
      <!-- NO TOCAR! Necessari per fases posteriors -->
      <!-- <ria-input name="address" label="Dirección" validation="required" type="text" :value="address" @change="changeValue"/>
      <ria-input name="zipcode" label="Código postal" validation="required" type="text" :value="zipcode" @change="changeValue"/>
      <ria-input-action
        :required="true"
        ref="id"
        :label="$t('participants.country')"
        name="country"
        :value="country"
        :action="openCountryPicker"
        @change="changeValue" />
      <ria-picker 
        v-if="isCountryPickerVisible"
        :label="$t('participants.countrypick')" 
        :filter="true"
        :options="countries" 
        @close="closeCountryPicker" 
        @select="changeCountry" />
      <ria-input 
        name="city" 
        :label="$t('participants.city')" 
        validation="required" 
        type="text" 
        :value="city" 
        @change="changeValue"/> -->

      <div class="send-to">
        <img class="icon" src="/img/icons/icon-mail.svg">
        <div>
          <div class="email">{{ order.email }}</div>
          <div class="email-text">{{ $t('participants.emailconfirm') }}</div>
        </div>
      </div>

    </template>
  </card>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import Card from "../common/card";
  import RiaInput from "./elements/ria-input";

  export default {
    name: "form-contact",
    components:{
      Card, 
      RiaInput,
    },
    data() {
      return {
        countries: {},
        isCountryPickerVisible: false,
        fieldsToValidate: ['email', 'firstname', 'lastname'],
        inputs: []
      }
    },
    computed: {
      ...mapGetters("customer", ["customer"]),
      ...mapGetters("order", ["order"]),
      ...mapGetters("resort", ["resort"]),
      isValid: function() {
        return this.fieldsToValidate.every((field) => this.order[field])
      },
      phoneValidation: function() {
        return this.resort.phone_required ? 'required' : 'optional'
      }
    },
    mounted() {
      this.inputs = Object.values(this.$refs)

      if(this.resort.phone_required)
        this.fieldsToValidate.push('phone')
    },
    // NECESSARI per a versions posteriors
    // async mounted(){
    //   const countries = await axios.get('https://restcountries.eu/rest/v2/all')
    //   this.countries = countries.data.map(country => ({name:country.translations[this.lang],value:country.alpha2Code.toLowerCase()}));
    // },
    methods: {
      ...mapMutations("order", ["SET_ORDER_FIELD"]),
      openCountryPicker() {
        this.isCountryPickerVisible = true;
      },
      closeCountryPicker() {
        this.isCountryPickerVisible = false;
      },
      changeCountry: function(countryCode) {
        //return this.countries.find( country => country.value === countryCode).name;
        this.country = countryCode;
      },
      changeValue: function({ field, value, hasErrors }) {
        if (!hasErrors) {
          this.SET_ORDER_FIELD({ field, value })
        }
      },
      checkValidations() {
        this.inputs.forEach(input => {
          if (input.isValid() instanceof Promise) {
            input.isValid().then((data) => input.showError = !data)
          } else {
            input.showError = !input.isValid()
          }
        })
      }
    }
  };
</script>

<style scoped>
  .send-to {
    @apply pt-3 flex items-start border-grey-border
  }

  .icon {
    @apply mr-2
  }

  .email {
    @apply font-medium text-xs
  }

  .email-text {
    @apply text-xs
  }

</style>
